import APIService from './APIService'

const api = APIService()

export const listDutyholderOrganisations = ({ search = '', page = 1 } = {}) =>
  api.get('/me/dutyholder-organisations', { params: { search, page } })

export const createDutyholderOrganisation = (body) =>
  api.post('/me/dutyholder-organisations', body)

export const updateDutyholderOrganisation = (id, body) =>
  api.patch(`/me/dutyholder-organisations/${id}`, body)
